import { useEffect } from "react";

const Redirect = ({ to, params }: { to: string; params?: string }) => {
  useEffect(() => {
    window.location.href = `${to}${params ? `?${params}` : ""}`;
  }, [to, params]);
  return null;
};

export default Redirect;
